import React, { useState, useContext } from "react";
import {
  Nav,
  NavItem,
  NavbarBrand,
  NavLink,
  NavbarToggler,
  NavbarText,
  Collapse,
  Navbar,
} from "reactstrap";
import { Link } from "react-router-dom";
import { UserContext } from "../context/UserContext";

const Header = () => {
  const context = useContext(UserContext);

  const [isOpen, setIsOpen] = useState(false);

  const toggler = () => setIsOpen(!isOpen);

  return (
    <Navbar color="info" className="fixed" light expand="md">
      <NavbarBrand>
        <Link to="/" className="text-white">
          GitFire App
        </Link>
      </NavbarBrand>
      <NavbarText className="text-white">
        {context.user?.email ? context.user.email : ""}
      </NavbarText>
      <NavbarToggler onClick={toggler} />
      <Collapse navbar isOpen={isOpen}>
        <Nav className="ml-auto" navbar>
          {context.user ? (
            <NavItem>
              <NavLink
                tag={Link}
                onClick={() => context.setUser(null)}
                to="/signin"
                className="text-white"
              >
                Logout
              </NavLink>
            </NavItem>
          ) : (
            <>
              <NavItem>
                <NavLink tag={Link} to="/signin" className="text-white">
                  SignIn
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} to="/signup" className="text-white">
                  SignUp
                </NavLink>
              </NavItem>
            </>
          )}
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default Header;
